/* eslint-disable camelcase */

import React from 'react';
import PropTypes from 'prop-types';
import looppa from 'looppa';
import { Trans } from 'translations';

export default function TableProductSpecs({ title_key, tbody, thead, notes }) {
    const tableTitle = thead.title && thead.title.length && thead.title[0];

    return (
        <div className="product-specs--table-wrapper">
            <h2 className="product-specs--title__table">
                <Trans path={title_key} />
            </h2>
            <table className="product-specs--table">
                <thead>
                    { tableTitle ? (
                        <tr>
                            <th colSpan={thead.data.length + 1} className="product-specs--table-ceil product-specs--table-th product-specs--table-th__main">
                                {tableTitle}
                            </th>
                        </tr>
                    ) : null }
                    <tr>
                        <th className="product-specs--table-ceil product-specs--table-th">&nbsp;</th>
                        {looppa(thead.data)((th, i) => (
                            <th className="product-specs--table-ceil product-specs--table-th" key={i}>
                                {th}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {looppa(tbody)((rows, key) => (
                        <tr className="product-specs--table--row" key={key}>
                            {looppa(rows.data)((value, j) => (
                                <td
                                    className={`product-specs--table-td product-specs--table-ceil ${ rows.has_border &&
                                        'product-specs--table-ceil__border' }`}
                                    key={j}
                                >
                                    {value}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            {notes ? <small className="product-specs--notes">{notes}</small> : null}
        </div>
    );
}

TableProductSpecs.propTypes = {
    tbody: PropTypes.array.isRequired,
    thead: PropTypes.object.isRequired,
    notes: PropTypes.string,
    title_key: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/product-specs/table/index.js